import { gql } from '@apollo/client';

export const getSucursalesCajas = gql`
query sucursalesCajas{
    sucursalesCaja(idSucursales:$idSucursales)  
    @rest(type: "SucursalesCajaModel", path: "/gateway/cajasseguridad/sucursales"){
        cod_ubic
        suc_nombre
        desc_localidad
        desc_partido
        descripcion
    }
}
` 